import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sortBy, map } from 'lodash';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import {
  getActiveBarberId,
  getCanShowProducts,
  getCanShowServices,
} from './selectors';
import { UNASSIGNED_BARBER } from '../constants';
import { getBarberServices } from '../../main/barbers/selector';
import * as discountsSelectors from '../../main/settings/discounts/selectors';
import {
  getActiveShopProductSalesToShop,
  getShopIdOrBarberUser,
  getRoleIdType,
  canActiveShopUseMemberships,
} from '../../auth/selectors';
import { hasCardReader } from '../../main/selectors';
import { mapCostToPrice } from '../helpers';
import Sale from './containers/Sale';
import * as servicesSelector from '../../main/services/selector';
import withFetchDataLoader from '../../common/hoc/withFetchDataLoader';
import { getSelectedDiscounts } from '../order/selectors';
import { addDiscount, addService } from '../order/actions';
import { canUserUseHandoff } from '../../common/helpers/users';
import withActiveUserIdAndType from '../../common/hoc/withActiveUserIdAndType';
import { setHandoff } from '../payment/reducer/handoff/actions';
import { withActionByRole } from '../../common/helpers/actions';
import * as actions from '../../main/services/actions';
import fetchTimeTracking from '../../main/timeTracker/hoc/barberListFetchTimeTracking';

const sortBarberServicesByShopServices = (barberServices, shopServices) => {
  const shopServicesIdSequence = map(shopServices, 'id');
  return sortBy(barberServices, item => shopServicesIdSequence.indexOf(item.id));
};

const mapStateToProps = (state, ownProps) => {
  const activeBarberId = getActiveBarberId(state);
  const productSalesToShop = getActiveShopProductSalesToShop(state);
  const shopServices = servicesSelector.getAll(state);
  const services = activeBarberId !== UNASSIGNED_BARBER ?
    sortBarberServicesByShopServices(getBarberServices(state, activeBarberId), shopServices) :
    shopServices;
  return {
    shopOrBarber: getRoleIdType(state),
    shopIdOrBarberUser: getShopIdOrBarberUser(state),
    services: mapCostToPrice(services),
    discounts: discountsSelectors.getDiscounts(state),
    selectedDiscounts: getSelectedDiscounts(state),
    baseUrl: ownProps.location.pathname,
    hasCardReader: hasCardReader(state, activeBarberId),
    activeBarberId,
    canShowServices: getCanShowServices(state, productSalesToShop),
    canShowProducts: getCanShowProducts(state, productSalesToShop),
    isHandoffAvailable: canUserUseHandoff(state.auth.permissions),
    canSellMemberships: ownProps.activeType === 'shop' && canActiveShopUseMemberships(state),
  };
};
const mapDispatchToProps = dispatch => bindActionCreators({
  addService,
  addDiscount,
  setHandoff,
}, dispatch);

export default compose(
  withRouter,
  withActiveUserIdAndType(),
  fetchTimeTracking,
  connect(mapStateToProps, mapDispatchToProps),
  withActionByRole(
    'fetchData', actions.getShopUserServices, actions.getBarberUserServices, actions.getBrandUserServices,
  ),
  withFetchDataLoader,
)(Sale);
